/**
 * Status Constants - Sipariş ve sipariş kalemleri için durum seçenekleri
 */

// Sipariş durumları
export const ORDER_STATUS_OPTIONS = [
  { value: "NEW", label: "Yeni", color: "default" },
  { value: "IN_PROGRESS", label: "Devam Ediyor", color: "processing" },
  { value: "COMPLETED", label: "Tamamlandı", color: "success" },
  { value: "CANCELLED", label: "İptal Edildi", color: "error" },
  { value: "FAILED", label: "Başarısız", color: "error" },
];

// Sipariş kalemi durumları
export const ORDER_ITEM_STATUS_OPTIONS = [
  { value: "NEW", label: "Yeni", color: "default" },
  { value: "IN_PROGRESS", label: "Devam Ediyor", color: "processing" },
  { value: "COMPLETED", label: "Tamamlandı", color: "success" },
  { value: "CANCELLED", label: "İptal Edildi", color: "error" },
];

/**
 * Durum değerine göre badge bilgisi döndürür
 * @param {string} status - Durum değeri (NEW, IN_PROGRESS, etc.)
 * @param {string} type - Durum tipi ("order" | "orderItem")
 * @returns {{ color: string, text: string }}
 */
export const getStatusInfo = (status, type = "order") => {
  const options = type === "orderItem" ? ORDER_ITEM_STATUS_OPTIONS : ORDER_STATUS_OPTIONS;
  const option = options.find(opt => opt.value === status);

  if (option) {
    return { color: option.color, text: option.label };
  }

  return { color: "error", text: "Bilinmiyor" };
};

/**
 * Durum seçeneklerini Select component için formatlar
 * @param {string} type - Durum tipi ("order" | "orderItem")
 * @returns {Array<{ value: string, label: string }>}
 */
export const getStatusOptions = (type = "order") => {
  const options = type === "orderItem" ? ORDER_ITEM_STATUS_OPTIONS : ORDER_STATUS_OPTIONS;
  return options.map(({ value, label }) => ({ value, label }));
};
